
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='page__error container'>\n  <div><img src='"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"img") || (depth0 != null ? lookupProperty(depth0,"img") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"img","hash":{},"data":data,"loc":{"start":{"line":2,"column":17},"end":{"line":2,"column":26}}}) : helper))) != null ? stack1 : "")
    + "' alt='404 error' loading='lazy' width='274' height='398' /></div>\n  <span class='error__text'>Incorrect request. Page not found</span>\n  <button class='button__error error__button' aria-label='back'>Go back to\n    main page</button>\n</div>";
},"useData":true});
                export default templateFunction;
                